import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { PinInputModal } from 'LocalGluons';
import NavigationService from 'NavigationService';
import { noop } from 'Utils';
import { t } from 'Locale';
import { useStore } from 'Store';
import { Device, getNetInfo, hideBars } from 'DeviceUtils';
import { useNavigationPropsContext } from '../../../../Navigation/navigationPropsContext';

const AppPinInputModal = ({
    fromPlayer,
    protectedContent,
    successCallback,
    closeCallback,
    forgotPinCallback,
    opaque
}) => {
    const { appManager, parentalLockConfig, setParentalLockConfig } = useStore();
    const navigation = NavigationService.getAppNavigationInstance();
    const [pinErrorMessage, setPinErrorMessage] = useState('');
    const { navigate } = useNavigationPropsContext();

    const onForgotPinCallback = () => {
        closeCallback();
        if (typeof forgotPinCallback === 'function') {
            forgotPinCallback();
        }
        navigate('ResetPin', {
            nextRoute: 'Details',
            nextRouteParams: { item: protectedContent }
        });
    };

    const onPinSuccessCallback = useCallback(() => {
        // Set config to unlocked
        setParentalLockConfig({ ...parentalLockConfig, unlocked: true });
        if (successCallback) {
            successCallback(protectedContent);
        } else {
            navigate(
                'Details',
                { item: protectedContent },
                { id: item.data.id, type: item.modelType }
            );
        }
        closeCallback(true);
    }, []);

    const pinValidateFunction = async (pin) => {
        if (!Device.isWeb) {
            const { isConnected } = await getNetInfo();
            if (!isConnected)
                return { errorMessage: t('COMMON.NETWORK_DISCONNECTED_MSG'), noInternet: true };
        }

        const result = await appManager.api.validatePin({ pin });
        if (!result) setPinErrorMessage('');

        return result ? null : { errorMessage: t('ERROR.WRONG_PIN') };
    };

    const cleanErrorMessage = async () => {
        setPinErrorMessage('');
    };

    const onPinFailed = (message) => {
        setPinErrorMessage(message);
    };

    useEffect(
        () => () => {
            if (fromPlayer) hideBars();
        },
        []
    );

    return (
        <PinInputModal
            header={t('COMMON.UNLOCK_PROGRAM_DIALOG_H')}
            message={t('SETTINGS.PARENTAL_CONTROL_ENTER_PARENTAL_PIN_INFO')}
            onPinSuccess={onPinSuccessCallback}
            onForgotPinPressed={onForgotPinCallback}
            pinValidateFunction={pinValidateFunction}
            onCancel={closeCallback}
            fromPlayer={fromPlayer}
            opaque={opaque}
            onPinFailed={onPinFailed}
            invalidPinMessage={pinErrorMessage}
            cleanErrorMessage={cleanErrorMessage}
        />
    );
};

AppPinInputModal.defaultProps = {
    fromPlayer: false,
    closeCallback: noop,
    successCallback: null,
    protectedContent: '',
    forgotPinCallback: noop,
    opaque: false
};

AppPinInputModal.propTypes = {
    fromPlayer: PropTypes.bool,
    closeCallback: PropTypes.func,
    successCallback: PropTypes.func,
    protectedContent: PropTypes.shape({}),
    forgotPinCallback: PropTypes.func,
    opaque: PropTypes.bool
};

export { AppPinInputModal };
